<div class="block">
  <h1>Fakturor</h1>
  <woo-tabs [default]="'attest'">
    <woo-tab label="Attest" name="attest">
      <invoice-attestation></invoice-attestation>
    </woo-tab>
    <woo-tab label="Fakturor" name="overview">
      <invoice-overview></invoice-overview>
    </woo-tab>
    <woo-tab label="Fakturaverktyg" name="tools">
      <invoice-tools></invoice-tools>
    </woo-tab>
  </woo-tabs>
</div>
